module.exports = __webpack_public_path__ + "img/4.714b9ded.png";